export default "__VITE_ASSET__DVSvpKN$__"